import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getAllowedRoutes } from '../utils'
import { Route, useHistory } from 'react-router-dom'
import './reporting.scss'
import Routes from '../routes'

const ReportingPage = (props) => {
  let history = useHistory()
  const allowedRoutes = getAllowedRoutes(props.children)

  if (props.location.pathname === Routes.REPORTING.PATH) {
    history.replace(allowedRoutes[0].path)
  }

  return (
    <div className="tabs-section reporting-page mb-3">
      <Tabs
        activeKey={props.location.pathname}
        onSelect={(e) => {
          history.push(e)
        }}
      >
        {allowedRoutes.map(({ path, title, component: Component }) => {
          return (
            <Tab
              key={path}
              eventKey={path}
              tabClassName={`tab-item ${path === props.location.pathname ? 'active' : ''}`}
              title={<FormattedMessage id={`${title}`} defaultMessage="Chart of Account" />}
            >
              <Route {...props} key={path} path={`${path}`}>
                <Component {...props} />
              </Route>
            </Tab>
          )
        })}
      </Tabs>
    </div>
  )
}

export default ReportingPage
